const firebaseKeys = {
    REACT_APP_API_KEY: "AIzaSyBHj0p_hMlGhgkfJZs_M5Aqa2lrIyO2IHM",
    REACT_APP_AUTH_DOMAIN: "codebattle-6ebec.firebaseapp.com",
    REACT_APP_PROJECT_ID: "codebattle-6ebec",
    REACT_APP_STORAGE_BUCKET: "codebattle-6ebec.appspot.com",
    REACT_APP_MESSAGING_SENDER_ID: "39722918062",
    REACT_APP_APP_ID: "1:39722918062:web:b3009776facc440396cd3f",
    REACT_APP_MEASUREMENT_ID: "G-8C15BZ2KWF",
    REACT_APP_CLIENT_ID: "386647217720-2e1rfd94535jcn2deetk5l47hrn1bqjq.apps.googleusercontent.com",
    REACT_APP_CLIENT_SECRET: "N50ElMGRCUCPZhxODlhVp7IT",
}

export default firebaseKeys;